export var VerifiedPaymentPages;
(function (VerifiedPaymentPages) {
    VerifiedPaymentPages["OVERVIEW"] = "overview";
    VerifiedPaymentPages["COMMUNITIES"] = "communities";
    VerifiedPaymentPages["TRANSACTIONS"] = "transactions";
})(VerifiedPaymentPages || (VerifiedPaymentPages = {}));
export const getVerifiedPaymentPageIndex = (name) => {
    return {
        [VerifiedPaymentPages.OVERVIEW]: 0,
        [VerifiedPaymentPages.COMMUNITIES]: 1,
        [VerifiedPaymentPages.TRANSACTIONS]: 2,
    }[name || VerifiedPaymentPages.OVERVIEW];
};
